import { compose, mapProps } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';

import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';

type Props = {
  courseSlug: string;
  search: string;
};

// The legacy VLP route was retired by the Freemium GA rollout (MONETIZE-2127).
// Every hit redirects to the consumer description page; the bundle entry
// point is preserved so the SSR pipeline can issue the redirect.
const VideoLoggedOutApp = () => null;

export default compose<Props, {}>(
  connectToRouter<Props>(({ params: { courseSlug }, location: { search } }) => ({
    courseSlug,
    search,
  })),
  mapProps(({ courseSlug, search, ...rest }: Props) => {
    redirectClientOrServer(`/learn/${courseSlug}${search}`);
    return rest;
  })
)(VideoLoggedOutApp);
